import config from '../../config';

export default function Socket(IgnoreServerErrors, sdk, $injector, $rootScope, $timeout) {
  'ngInject';

  const { webSocketService } = sdk('context');
  webSocketService.customCallback = null;

  if (config.WEBSOCKETS_OFF && !__TEST__) {
    console.warn(
      '%c💣 BE WARNED ️️️️💣\nFORCED WEB SOCKETS OFF VIA\nconfig.WEBSOCKETS_OFF',
      'font-size: 20px;'
    );
  }

  if (__HEADLESS__) {
    return {};
  }

  webSocketService.setCustomCallback = (callback) => {
    webSocketService.customCallback = callback;
  };

  webSocketService.onMessage(async (data) => {
    if (data && data.command) {
      await $timeout(0);

      IgnoreServerErrors.ignoreInCurrentDigestCycle();
      // console.warn('socket:' + data.command, data.msg);
      $rootScope.$broadcast(`socket:${data.command}`, data.msg);

      if (webSocketService.customCallback) {
        webSocketService.customCallback(`socket:${data.command}`, data.msg);
      }
    }
  });

  return webSocketService;
}
